import React from 'react'
import classNames from 'classnames'
import styles from './HorizontalSquiggly.module.css'

export type HorizontalSquigglyVariant = 'grey' | 'white'

type Props = {
  /** `white` for use on dark or coloured backgrounds. Defaults to `grey`. */
  variant?: HorizontalSquigglyVariant
}

/**
 * A repeating squiggly rule used to divide sections.
 *
 * @param {Props} props - The squiggly props.
 * @returns {React.ReactElement<HTMLDivElement>} The rendered divider.
 */
const HorizontalSquiggly = ({ variant = 'grey' }: Props = {}): React.ReactElement<HTMLDivElement> => (
  <div
    className={classNames(styles.HorizontalSquiggly, { [styles.White]: variant === 'white' })}
    data-testid="horizontal-squiggly"
  />
)

export default HorizontalSquiggly
